import type {SxProps} from '@mui/material';
import {Autocomplete} from '@mui/material';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import type {FC, ReactNode, SyntheticEvent} from 'react';

// TYPES
export type StringOption = {
  uuid: string;
  name: string;
};

type Props = {
  value?: string;
  options?: Array<string>;
  required?: boolean;
  startAdornment?: ReactNode;
  onValueChange: (optionId: string) => void;
};

const AutocompleteSelect: FC<Props> = ({value, options = [], onValueChange}) => {
  const handleChange = (_e: SyntheticEvent, newVal: string | undefined) => {
    if (newVal) {
      onValueChange(newVal);
    }
  };

  return (
    <Stack direction="row" spacing={1} sx={styles.container}>
      <Autocomplete
        value={value}
        onChange={handleChange}
        options={options}
        getOptionLabel={(option) => option}
        isOptionEqualToValue={(option, val) => option === val}
        disableClearable
        size="small"
        renderInput={(params) => <TextField {...params} /*variant="outlined"*/ />}
        sx={styles.autocomplete}
        slotProps={{
          popper: {
            placement: 'bottom-start',
          },
          paper: {
            sx: {
              maxHeight: 300,
              mt: 0.5,
            },
          },
        }}
      />
    </Stack>
  );
};

const styles: Record<string, SxProps> = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 500ms ease-in-out',
    borderRadius: 1,
    width: '100%',
  },
  autocomplete: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      bgcolor: 'common.white',
      padding: 0,
      height: '36px',
      mb: 1.5,
      '& input': {
        padding: '8px 4px !important',
        fontSize: 'inherit',
      },
    },
  },
};

export default AutocompleteSelect;
